import { lazy, Suspense } from 'react'
import { createBrowserRouter, Outlet } from 'react-router'
import { Shell } from './Shell'

const lazyPage = (factory: () => Promise<{ default: React.ComponentType }>) => {
  const C = lazy(factory)
  return (
    <Suspense fallback={<PageFallback />}>
      <C />
    </Suspense>
  )
}

function PageFallback() {
  return (
    <div className="grid h-full place-items-center text-[var(--color-muted)]">
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-[var(--color-surface-3)] border-t-[var(--color-accent)]" />
    </div>
  )
}

export const router = createBrowserRouter([
  {
    element: (
      <Shell>
        <Outlet />
      </Shell>
    ),
    children: [
      { index: true, element: lazyPage(() => import('@/features/home/HomeScreen')) },
      { path: 'rooms', element: lazyPage(() => import('@/features/rooms/RoomsScreen')) },
      { path: 'rooms/:roomId', element: lazyPage(() => import('@/features/rooms/RoomsScreen')) },
      { path: 'climate', element: lazyPage(() => import('@/features/climate/ClimateScreen')) },
      { path: 'energy', element: lazyPage(() => import('@/features/energy/EnergyScreen')) },
      { path: 'media', element: lazyPage(() => import('@/features/media/MediaScreen')) },
      { path: 'security', element: lazyPage(() => import('@/features/security/SecurityScreen')) },
      { path: 'car', element: lazyPage(() => import('@/features/car/CarScreen')) },
      { path: 'household', element: lazyPage(() => import('@/features/household/HouseholdScreen')) },
      { path: 'system', element: lazyPage(() => import('@/features/system/SystemScreen')) },
      { path: 'lab', element: lazyPage(() => import('@/lab/LabScreen')) },
    ],
  },
])
